import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiClient } from '../utils/api';
import { useToast } from '../components/common/ToastProvider';
import '../styles/components.css';

export function RegisterPage() {
    const navigate = useNavigate();
    const { addToast } = useToast();
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setError(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const payload = {
                firstname: formData.firstname,
                lastname: formData.lastname,
                email: formData.email,
                password: formData.password
            };

            await apiClient.register(payload);

            setSuccess(true);
            addToast({
                type: 'success',
                title: 'Registration Successful',
                description: 'Please contact an administrator to verify your account.'
            });

            // Redirect to login after a short delay
            setTimeout(() => {
                navigate('/login');
            }, 3000);

        } catch (err) {
            const message = err.message || 'Registration failed. Please try again.';
            setError(message);
            addToast({
                type: 'error',
                title: 'Registration Failed',
                description: message
            });
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="auth-wrapper">
                <div className="auth-card">
                    <h1 className="auth-card__title">Registration Successful</h1>
                    <div className="auth-form">
                        <div className="auth-error" style={{ background: 'rgba(109, 255, 178, 0.16)', borderColor: 'rgba(109, 255, 178, 0.3)', color: 'var(--color-success)' }}>
                            <p>Your account has been created.</p>
                            <p>Please contact an administrator to activate your account before logging in.</p>
                            <p>Redirecting to login...</p>
                        </div>
                        <Link to="/login" className="primary-btn auth-submit" style={{ textAlign: 'center', textDecoration: 'none', display: 'block', lineHeight: '2.5' }}>
                            Go to Login
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <h1 className="auth-card__title">Create Account</h1>

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-field">
                        <label className="form-label" htmlFor="firstname">First Name</label>
                        <input
                            type="text"
                            id="firstname"
                            name="firstname"
                            value={formData.firstname}
                            onChange={handleChange}
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="form-field">
                        <label className="form-label" htmlFor="lastname">Last Name</label>
                        <input
                            type="text"
                            id="lastname"
                            name="lastname"
                            value={formData.lastname}
                            onChange={handleChange}
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="form-field">
                        <label className="form-label" htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            disabled={loading}
                            autoComplete="username"
                        />
                    </div>

                    <div className="form-field">
                        <label className="form-label" htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            minLength={8}
                            disabled={loading}
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="form-field">
                        <label className="form-label" htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                            minLength={8}
                            disabled={loading}
                            autoComplete="new-password"
                        />
                    </div>

                    {error && <div className="auth-error">{error}</div>}

                    <button type="submit" className="primary-btn auth-submit" disabled={loading}>
                        {loading ? 'Registering...' : 'Register'}
                    </button>

                    <div className="auth-footer" style={{ marginTop: '1rem', textAlign: 'center' }}>
                        <p>
                            Already have an account? <Link to="/login">Login here</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}
